var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"color":"red","text":"","icon":"","large":""},on:{"click":_vm.endCall}},[_c('v-icon',{attrs:{"large":""}},[_vm._v("mdi-phone-hangup")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }